import { render } from "./SubthemeForm.vue?vue&type=template&id=4660fde7"
import script from "./SubthemeForm.vue?vue&type=script&lang=js"
export * from "./SubthemeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__